import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import marcaService from "../services/marcaService";
import { message } from "utils/Funciones";

const initialState = {
    responseSuccessCreate: null,
    responseSuccessGet: null,
    responseSuccessUpdate: null,
    responseSuccessDelete: null,
    data: [],
    dataByPage: [],
    totalRow: 0,
    totalPage: 0,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
    totalStoreValue: 0
};

export const create = createAsyncThunk(
    "marca/create",
    async (data, thunkAPI) => {
        try {
            return await marcaService.create(data.formData, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const get = createAsyncThunk(
    "marca/get",
    async (token, thunkAPI) => {
        try {
            return await marcaService.get(token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getByPage = createAsyncThunk(
    "marca/getByPage/bypage",
    async (data, thunkAPI) => {
        try {
            return await marcaService.getByPage(data.query, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const update = createAsyncThunk(
    "marca/update/marca",
    async (data, thunkAPI) => {
        try {
            return await marcaService.update(data.formData, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const del = createAsyncThunk(
    "marca/del",
    async (data, thunkAPI) => {
        try {
            return await marcaService.del(data._id, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

const marcaSlice = createSlice({
    name: "marca",
    initialState,
    reducers: {
        SET_TO_DEFAULT_RESPONSE(state, action) {
            state.responseSuccessCreate = null
            state.responseSuccessGet = null
            state.responseSuccessUpdate = null
            state.responseSuccessDelete = null
        },

        UPDATE_MARCA_FROM_SOCKET(state, action) {


        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(create.pending, (state) => {
                //state.isLoading = true;
            })
            .addCase(create.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessCreate = action.payload;
            })
            .addCase(create.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(get.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(get.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.data = action.payload.data;
            })
            .addCase(get.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getByPage.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getByPage.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.dataByPage = action.payload.data;
                state.totalPage = action.payload.totalPage;
                state.totalRow = action.payload.totalRow;
            })
            .addCase(getByPage.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })


            .addCase(update.pending, (state) => {
                //state.isLoading = true;
            })
            .addCase(update.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessUpdate = action.payload;
                const newState = state.dataByPage.map((item) => {
                    if (item._id === action.payload.newStateData.newData._id) {
                        return {
                            ...item,
                            name: action.payload.newStateData.newData.name,
                            disabled: action.payload.newStateData.newData.disabled,
                            last_update: action.payload.newStateData.newData.last_update
                        }
                    }
                    return item
                })
                state.dataByPage = newState
            })
            .addCase(update.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })

            .addCase(del.pending, (state) => {
                //state.isLoading = true;
            })
            .addCase(del.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessDelete = action.payload;
            })
            .addCase(del.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
    },
});

export const { UPDATE_MARCA_FROM_SOCKET, SET_TO_DEFAULT_RESPONSE } = marcaSlice.actions;

export default marcaSlice.reducer;

